// extracted by mini-css-extract-plugin
module.exports = {"root":"RatingDisplay-module_root_1_tpy","stars":"RatingDisplay-module_stars_3IuJs","filled":"RatingDisplay-module_filled_3aLa5","label":"RatingDisplay-module_label_WXVV7"};